module.exports = __webpack_public_path__ + "static/media/clouds.d5aedfae.svg";